import React from 'react';
import { analyticsInteraction } from 'utils/analytics';
import { i18n } from 'utils/i18n';
import { sanitize } from 'utils/validation';
import { config } from 'utils/config';
import { loadingRedirect } from 'utils/redirect';
import { ModalFooter } from 'components/Modal/ModalFooter';
import { MODAL_BUTTON_TYPES } from 'constants/modals';
import WINDOW_OBJECT_KEYS from 'constants/windowObjectKeys';
import ANALYTICS from 'constants/analytics';
import { SOURCE_CODE } from 'constants/urlParam';

const DealsEmailSpecialsModalContent = ({ descriptionID }) => {
  const buttonsArray = [
    {
      type: MODAL_BUTTON_TYPES.DECLINE,
      label: i18n('deals_email_specials_modal_no_button'),
      analyticsKey: ANALYTICS.EMAIL_SIGNUP_MODAL,
      analyticsValue: ANALYTICS.NO_THANKS_SIGNUP_MODAL,
      showButton: !config.isNADomain(),
    },
    {
      type: MODAL_BUTTON_TYPES.ACCEPT,
      label: i18n('deals_email_specials_modal_sign_up_button'),
      handler: () => {
        const searchParams = new URLSearchParams();
        searchParams.set(SOURCE_CODE, config.getDealsModalSourceCode());
        loadingRedirect(WINDOW_OBJECT_KEYS.EMAIL_SPECIALS, true, null, searchParams);
      },
      analyticsHandler: () => analyticsInteraction(ANALYTICS.MODAL, ANALYTICS.EMAIL_SIGNUP_MODAL, ANALYTICS.SIGN_UP),
      // The handler above can be removed when the bug with the modal buttons' link type is fixed
      // These are not used because analytics are not tracked for links due to the bug listed above
      analyticsKey: ANALYTICS.EMAIL_SIGNUP_MODAL,
      analyticsValue: ANALYTICS.SIGN_UP,
      showButton: true,
    },
  ];
  return (
    <div className='modal-content__inner padding-top--condensed'>
      <p id={descriptionID} dangerouslySetInnerHTML={sanitize(i18n('deals_email_specials_modal_sign_up'))} />
      <ModalFooter fullWidthButton disableStickyFooter buttons={buttonsArray.filter((item) => item.showButton)} />
    </div>
  );
};
export default DealsEmailSpecialsModalContent;
